/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fast_Wry_Puma_CurlInputs */

const en_fast_wry_puma_curl = /** @type {(inputs: Fast_Wry_Puma_CurlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create one entry per feedback group`)
};

const de_fast_wry_puma_curl = /** @type {(inputs: Fast_Wry_Puma_CurlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einträge pro Feedback-Gruppe erstellen`)
};

/**
* | output |
* | --- |
* | "Create one entry per feedback group" |
*
* @param {Fast_Wry_Puma_CurlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fast_wry_puma_curl = /** @type {((inputs?: Fast_Wry_Puma_CurlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fast_Wry_Puma_CurlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fast_wry_puma_curl(inputs)
	return de_fast_wry_puma_curl(inputs)
});